import { render, staticRenderFns } from "./VideoSI.vue?vue&type=template&id=60ec9d5d&scoped=true"
import script from "./VideoSI.vue?vue&type=script&lang=js"
export * from "./VideoSI.vue?vue&type=script&lang=js"
import style0 from "./VideoSI.vue?vue&type=style&index=0&id=60ec9d5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec9d5d",
  null
  
)

export default component.exports